// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { BaseEntity } from '../base-entity';
import { Address } from './address';
import { Bankrupt } from './bankrupt';

/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class BankruptAddress extends BaseEntity  {

  /// <code> Place custom code between <code> tags
  
  /// </code>

  // Generated code. Do not place code below this line.
  bankruptId!: number;
  addressId!: number;
  ts!: string;
  address!: Address;
  bankrupt!: Bankrupt;
}

